module.exports = __webpack_public_path__ + "public/img/yibiaopan_lv_29.f64691e0.png";